import Vue from 'vue'

Vue.component('icon', require('@/components/atoms/Icon').default)
Vue.component('svg-icon', require('@/components/atoms/SvgIcon').default)
Vue.component('retina-image', require('@/components/atoms/RetinaImage').default)
Vue.component('navbar', require('@/components/organisms/Navbar').default)
Vue.component(
  'background',
  require('@/components/containers/Background').default
)
Vue.component(
  'background-image',
  require('@/components/containers/BackgroundImage').default
)
Vue.component(
  'popup-navigation-bar',
  require('@/components/molecules/PopupNavigationBar').default
)
Vue.component(
  'loading-indicator',
  require('@/components/atoms/LoadingIndicator').default
)
Vue.mixin(require('@/components/mixins/QueryParser').default)
Vue.mixin({
  mounted() {
    document.documentElement.style.webkitUserSelect = 'none'
    document.documentElement.style.webkitTouchCallout = 'none'
  },
})
Vue.mixin(require('@/components/mixins/PathResolver').default)
